<template>
  <div class="h-screen ">
    <div
      class="container mx-auto h-full"
    >
      <router-view />
    </div>
  </div>
</template>

<script>
export default {

}
</script>
